import { Box, Typography } from '@mui/material';

export default function HelperText(props) {
    const CharacterCounter = () => (
        <Box component="span" display="flex" justifyContent="flex-end">
            {props.meta.value?.length ?? 0}/{props.maxLength}
        </Box>
    );

    const Text = () => (
        <Typography component="span" sx={{ color: 'common.gray', fontSize: theme => `${theme.typography.pxToRem(12)} !important`, lineHeight: '20px', letterSpacing: '0.4px' }}>
            {props.helperText}
        </Typography>
    );

    return (
        <Box
            component="span"
            sx={{
                display: 'flex',
                justifyContent: props.maxLength
                    ? 'space-between'
                    : props.meta?.error && props.maxLength
                    ? 'space-between'
                    : props.meta?.error || props.helperText
                    ? 'flex-start'
                    : 'flex-end'
            }}
        >
            {props.meta?.error ? (
                <>
                    {Array.isArray(props.meta.error) ? props.meta.error[0] : props.meta.error}
                    {props.maxLength && <CharacterCounter />}
                </>
            ) : (
                <>
                    {props.helperText && <Text />}
                    {props.maxLength && <CharacterCounter />}
                </>
            )}
        </Box>
    );
}
